import { Film, Smartphone, Scissors, Clock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const Tip = ({ icon: Icon, title, children }) => (
  <div className="flex gap-3">
    <span className="shrink-0 w-8 h-8 rounded-full bg-[#5d8a52]/25 text-[#a9d79b] flex items-center justify-center"><Icon size={16} /></span>
    <div className="text-sm text-white/85 leading-snug"><p className="font-extrabold text-white mb-0.5">{title}</p>{children}</div>
  </div>
);

export default function VideoTipsModal({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-[#0f0f16] border-2 border-[#5d8a52] text-white max-w-md" data-testid="video-tips-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[#f0c975] text-lg font-extrabold"><Film size={18} /> Video clip tips</DialogTitle>
          <DialogDescription className="text-white/70">3 to 15 clips · each adds ~10s (3 clips ≈ 30s, 15 clips ≈ 2½ min) · 40MB max each</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <Tip icon={Clock} title="Only the first 10 seconds play">If your voice-over runs longer, the last frame holds until it finishes.</Tip>
          <Tip icon={Smartphone} title="Faster uploads: shoot at 720p or 1080p · 30fps">Settings → Camera → Record Video → <b>720p HD at 30 fps</b> (or <b>1080p at 30 fps</b> if 720p isn't listed), and Formats → <b>High Efficiency</b>. A 10s clip lands around 4–10MB.</Tip>
          <Tip icon={Scissors} title="We shrink it for you">Clips up to 40MB are accepted and automatically shrunk to video-ready size after upload — no extra apps needed. (Stuck with a huge 4K file? See the FAQ for the free HandBrake fix.)</Tip>
        </div>
        <button type="button" onClick={onClose} data-testid="video-tips-close" className="mt-2 w-full rounded-full bg-[#dc2626] hover:bg-[#b91c1c] py-2.5 font-extrabold transition-colors">Got it</button>
      </DialogContent>
    </Dialog>
  );
}
